export default "__VITE_ASSET__CZ8iJkPE__"